import * as React from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate, useRoutes } from "react-router-dom";

import { Paths } from "./constants/paths";
import {
    TestContainer,
} from "./containers";
import { CoeRepro } from "./pages/CoeRepro";

const testRoutes: RouteObject[] = [
    {
        path: Paths.TEST,
        element: <TestContainer />,
    },
];
const routes: RouteObject[] = [
    ...(process.env.NODE_ENV === "development" ? testRoutes : []),
    {
        path: Paths.HOME,
        element: <CoeRepro />,
    },
    {
        path: "/coe-repro",
        element: <CoeRepro />,
    },
    { path: "/*", element: <Navigate to="/" replace /> },
    { path: "*", element: <Navigate to="/" replace /> },
];

const wildcardMatcher = /^#\//;

const RoutePaths: React.FunctionComponent = () => {
    const elements = useRoutes(routes);
    React.useEffect(() => {
        if (!wildcardMatcher.test(window.location.hash)) {
            window.location.hash = "";
        }
    }, [window.location.hash]);
    return elements;
};

export default RoutePaths;
